import React, { Component, Suspense } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import ForgotPassword from './ForgotPassword';
//import MutationObserver from 'react-mutation-observer';
import HttpsRedirect from 'react-https-redirect';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/material/styles';

import { CircularProgress, Alert, Snackbar, Box, Typography, Paper, Backdrop } from '@mui/material'
import './App.css';
import LoginPage from './LoginPage';
import ASCAuthS1 from './ASCAuth/Step1';
import ASCAuthS2 from './ASCAuth/Step2';
import { returnAccess } from './utility/returnAccess'
import NewUser from './NewUser';
import ConfirmUser from './ConfirmUser';
import { returnCookieValue } from './utility/returnCookieValue';
import { dropCookie } from './utility/dropCookie';
import * as config from './Config/config';
import { resetStorage } from './utility/resetStorage';
import CookieDrop from './components/CookieDrop/CookieDrop'
import ErrorBoundary from './hoc/ErrorBoundary/ErrorBoundary'
import ErrorPage from './components/PlaceHolder/Error';
import { secureStorage_getItem } from './utility/secureStorage';
import { loadHubSpot, removeHubSpot } from './utils/hubspot';
import backgroundImage from './assets/img/db-bg.jpg';
import { getLoginUrl } from './Config/auth.config';
import { exchangeCodeForTokens } from './services/authService';
import { extractUserInfo, storeUserSession } from './utils/tokenUtils';
import { setupUserSession } from './services/managedAuthService';
import apigClientFactory from './chalice-javascript-sdk/apigClient';

// const NavWrapper = React.lazy(() => import('./NavWrapper'))
const NDNavWrapper = React.lazy(() => import('./Dashboardv3.0/newComponents/NavWrapper'))

const drawerWidth = 240;

const StyledContainer = styled('div')({
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    minHeight: '100vh'
});

class App extends Component {
    state = {
        showReviewMessage: false,
        isNewSignup: false,
        userStatus: null,
        isLoading: true,
        userInfo: null,
        showTimeoutDialog: false
    }

    once(fn, context) {
        var result;
        return function () {
            if (fn) {
                result = fn.apply(context || this, arguments);
                fn = null;
            }
            return result;
        }
    }

    check = () => {
        // If we have a code in URL or are on login page, consider session active
        const urlParams = new URLSearchParams(window.location.search);
        const hasCode = urlParams.get('code');
        const isLoginPage = window.location.pathname === '/login';

        // Check if path is exempt from auth
        const isExemptPath = ['/login', '/forgotPassword', '/newUser', '/confirmUser', '/vlomni/cookie/drop'].includes(this.props.location.pathname);

        // If on exempt path or have code, allow access
        if (isExemptPath || hasCode) {
            return true;
        }

        // Check if user has valid tokens and session using secureStorage
        const hasValidTokens = secureStorage_getItem('accesstoken') && secureStorage_getItem('updatetoken');
        const sessionActive = returnCookieValue('vlomni-cookie-active') !== null;

        return hasValidTokens && sessionActive;
    }

    init = this.once(function () {
        this.check();
    })

    constructor(props) {
        super(props);
        this.init();
        console.log('version_update - apr-22-2025');
    }

    async componentDidMount() {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');

            // Set initial session cookie for auth flow
            if (code) {
                const now = new Date().getTime();
                dropCookie('vlomni-cookie-active', now, config.SESSION_EXPIRESIN);
            }

            // First check if we have existing user info
            let existingUserInfo = null;
            let existingStatus = null;

            try {
                const userInfoStr = localStorage.getItem('vlomni_user_info');
                existingUserInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
                existingStatus = localStorage.getItem('vlomni_user_status');
            } catch (error) {
                console.error('Error parsing stored user info:', error);
            }

            if (code) {

                // Exchange code for tokens first
                const tokens = await exchangeCodeForTokens(code);

                if (tokens) {
                    // Extract user info from ID token
                    const userInfo = await extractUserInfo(tokens.id_token);

                    if (userInfo) {
                        try {
                            // Set up complete user session with all required data
                            await setupUserSession(tokens, userInfo);
                            // Update component state
                            this.setState({
                                isNewSignup: !userInfo.status || userInfo.status === 'pending_review',
                                showReviewMessage: userInfo.status === 'pending_review',
                                userStatus: userInfo.status,
                                isLoading: false,
                                userInfo,
                                showTimeoutDialog: false
                            });

                            // Remove code from URL without page refresh
                            const newUrl = window.location.pathname;
                            window.history.replaceState({}, document.title, newUrl);
                            return; // Exit early after successful setup
                        } catch (error) {
                            console.error('Error setting up user session:', error);
                        }
                    }
                }
            }

            // If we get here, either there was no code or token exchange failed
            // Try to use existing user info
            if (existingUserInfo && existingStatus) {
                this.setState({
                    isNewSignup: !existingStatus || existingStatus === 'pending_review',
                    showReviewMessage: existingStatus === 'pending_review',
                    userStatus: existingStatus,
                    isLoading: false,
                    userInfo: existingUserInfo,
                    showTimeoutDialog: false
                });
            } else {
                this.setState({
                    isLoading: false,
                    userStatus: null,
                    showTimeoutDialog: false
                });
            }

            // Check if user is logged in and HubSpot should be loaded
            const shouldLoadHubSpot = localStorage.getItem('hubspot_enabled') === 'true';
            if (shouldLoadHubSpot) {
                loadHubSpot();
            }

            // Add history listener
            this.unlisten = this.props.history.listen((location, action) => {
                if (returnCookieValue("vlomni-cookie-active") !== null) {
                    dropCookie("vlomni-cookie-active", new Date().getTime(), config.SESSION_EXPIRESIN);
                }
                // Hide timeout dialog on navigation
                if (this.state.showTimeoutDialog) {
                    this.setState({ showTimeoutDialog: false });
                }
            });

        } catch (error) {
            console.error('Error in componentDidMount:', error);
            this.setState({
                isLoading: false,
                userStatus: null
            });
        }
    }

    componentWillUnmount() {
        // Clean up HubSpot
        removeHubSpot();

        // Remove history listener
        if (this.unlisten) {
            this.unlisten();
        }
    }

    handleCloseMessage = () => {
        this.setState({ showReviewMessage: false });
    }

    renderUnderReviewPage = () => {
        const handleLogout = () => {
            // Clear all storage and redirect to login
            resetStorage();
            window.location.href = getLoginUrl();
        };

        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    position: 'relative',
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(26,26,26,0.95) 100%)',
                        pointerEvents: 'none'
                    }
                }}
            >
                {/* Company Logo */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: '2rem',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        mb: 4
                    }}
                >
                    <img
                        src="https://customerui-profile-icons.s3.us-east-1.amazonaws.com/VLdashboard-loginlogo.png"
                        alt="eHouse Studio"
                        style={{
                            height: '50px',
                            marginBottom: '2rem'
                        }}
                    />
                </Box>

                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        maxWidth: 600,
                        textAlign: 'center',
                        borderRadius: 2,
                        backgroundColor: 'rgba(255, 255, 255, 0.98)',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                        position: 'relative',
                        zIndex: 1
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h1"
                        gutterBottom
                        sx={{
                            color: '#333',
                            fontWeight: 600,
                            mb: 3
                        }}
                    >
                        Account Under Review
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: '#555',
                            mb: 2,
                            fontSize: '1.1rem',
                            lineHeight: 1.6
                        }}
                        paragraph
                    >
                        Thank you for signing up! Your account is currently under review by our team.
                        We'll notify you once the review is complete and your account is activated.
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#666',
                            mb: 4
                        }}
                        paragraph
                    >
                        This usually takes 1-2 business days. You can check the status of your review
                        and communicate with our team through our support ticket system.
                    </Typography>
                    <Box
                        sx={{
                            mt: 3,
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 3,
                            flexWrap: 'wrap'
                        }}
                    >
                        <a
                            href="https://support.ehousestudio.com/tickets-view?offset=0&view=all_tickets"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                        >
                            <Paper
                                elevation={2}
                                sx={{
                                    p: 2,
                                    px: 4,
                                    bgcolor: '#673AB7', // Purple brand color
                                    color: 'white',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        bgcolor: '#5E35B1',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 4px 12px rgba(103, 58, 183, 0.3)'
                                    },
                                    display: 'inline-block',
                                    transition: 'all 0.2s ease-in-out',
                                    borderRadius: '25px'
                                }}
                            >
                                <Typography
                                    variant="button"
                                    sx={{
                                        fontWeight: 600,
                                        letterSpacing: '0.5px'
                                    }}
                                >
                                    View Support Tickets
                                </Typography>
                            </Paper>
                        </a>

                        <Paper
                            elevation={2}
                            onClick={handleLogout}
                            sx={{
                                p: 2,
                                px: 4,
                                bgcolor: '#f5f5f5', // Light gray background
                                color: '#555',
                                cursor: 'pointer',
                                '&:hover': {
                                    bgcolor: '#e0e0e0',
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                                },
                                display: 'inline-block',
                                transition: 'all 0.2s ease-in-out',
                                borderRadius: '25px'
                            }}
                        >
                            <Typography
                                variant="button"
                                sx={{
                                    fontWeight: 600,
                                    letterSpacing: '0.5px'
                                }}
                            >
                                Logout
                            </Typography>
                        </Paper>
                    </Box>
                    <Typography
                        variant="body2"
                        sx={{
                            mt: 3,
                            color: '#777',
                            fontSize: '0.875rem',
                            maxWidth: '80%',
                            mx: 'auto'
                        }}
                    >
                        You can view and track all communications regarding your account review through our support ticket system.
                    </Typography>
                </Paper>

                {/* Optional: Add decorative elements */}
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: '2rem',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        color: 'rgba(255, 255, 255, 0.5)',
                        fontSize: '0.875rem',
                        textAlign: 'center'
                    }}
                >
                    <Typography variant="caption">
                        © {new Date().getFullYear()} eHouse Studio. All rights reserved.
                    </Typography>
                </Box>
            </Box>
        );
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </div>
            );
        }

        // Check for valid session or auth flow
        const urlParams = new URLSearchParams(window.location.search);
        const hasCode = urlParams.get('code');
        const isLoginPage = window.location.pathname === '/login';
        const hasValidSession = this.check();

        // If no valid session and not on login page or auth flow, redirect to login
        if (!hasValidSession && !hasCode && !isLoginPage) {
            window.location.replace(getLoginUrl());
            return null;
        }

        // Show error page if there's an error
        if (this.state.userStatus === 'error') {
            return (
                <HttpsRedirect>
                    <ErrorBoundary>
                        <ErrorPage />
                    </ErrorBoundary>
                </HttpsRedirect>
            );
        }

        // Show review page for pending review users
        if (this.state.userStatus === 'pending_review') {
            return (
                <HttpsRedirect>
                    <ErrorBoundary>
                        {this.renderUnderReviewPage()}
                    </ErrorBoundary>
                </HttpsRedirect>
            );
        }

        // Show main dashboard for approved users
        return (
            <HttpsRedirect>
                <ErrorBoundary>
                    <Snackbar
                        open={this.state.showReviewMessage}
                        autoHideDuration={6000}
                        onClose={this.handleCloseMessage}
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    >
                        <Alert onClose={this.handleCloseMessage} severity="info" sx={{ width: '100%' }}>
                            Your account is currently being reviewed.
                        </Alert>
                    </Snackbar>
                    {this.state.showTimeoutDialog && (
                        <div className="time-out-message" style={{ fontFamily: "Lato" }}>
                            <Backdrop style={{ zIndex: "10000", backgroundColor: "rgba(0,0,0,0.5)" }} open={true}>
                            </Backdrop>
                            <div style={{ position: "fixed", zIndex: 10001, top: "50%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: 'white', borderRadius: '0.5em', padding: '2em' }} >
                                <span id="message-id">Your session has timed out.<br /> <span style={{ textDecoration: "underline", cursor: "pointer", color: "dodgerblue" }} onClick={this.handlePopupClose}>Click here</span> to log in again.</span>
                            </div>
                        </div>
                    )}
                    <Route path='/'>
                        <Suspense fallback={<div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress /></div>}>
                            <StyledContainer>
                                <Switch>
                                    <Route exact path="/error" component={ErrorPage} />
                                    <Route path='/vlomni/cookie/drop' component={CookieDrop} />
                                    <Route path='/vlomni-authorize-amazon-seller-central' component={ASCAuthS1} />
                                    <Route path='/vlomni-authorize-amazon-vendor-central' component={ASCAuthS1} />
                                    <Route path='/vlomni-amazon-api-authorize' component={ASCAuthS2} exact />
                                    <Route path='/confirmUser' component={ConfirmUser} exact />
                                    <Route key='dynRoute' path='/' component={NDNavWrapper} />
                                </Switch>
                            </StyledContainer>
                        </Suspense>
                    </Route>
                </ErrorBoundary>
            </HttpsRedirect>
        );
    }

    // Add helper method to check user status
    checkUserStatus = () => {
        const userStatus = localStorage.getItem('vlomni_user_status');
        const authTimestamp = localStorage.getItem('vlomni_auth_timestamp');
        const currentTime = new Date().getTime();

        // If no status or auth timestamp, user needs to login
        if (!userStatus || !authTimestamp) {
            return 'needs_login';
        }

        // If user is pending review
        if (userStatus === 'pending_review') {
            // You can add logic here to check against your backend 
            // to see if the review is complete
            return 'pending_review';
        }

        // If user is approved
        if (userStatus === 'approved') {
            return 'approved';
        }

        return 'unknown';
    }
}

export default withRouter(App);